module.exports = __webpack_public_path__ + "img/new1-img5.9931efea.png";